const tabs = [
  "Overview",
  "Items",
  "Members",
  
];

const WorkspaceNavigation = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="border-b border-slate-200 bg-white px-6">

      <div className="flex gap-8">

        {tabs.map((tab) => (

          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`relative py-4 text-sm font-semibold transition-colors ${
              activeTab === tab
                ? "text-blue-600"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            {tab}

            {activeTab === tab && (
              <span className="absolute bottom-0 left-0 h-[3px] w-full rounded-full bg-blue-600" />
            )}

          </button>

        ))}

      </div>

    </div>
  );
};

export default WorkspaceNavigation;